import { render } from "./DeletedPersonal.vue?vue&type=template&id=54b0a71b"
import script from "./DeletedPersonal.vue?vue&type=script&lang=js"
export * from "./DeletedPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__